import { filterClasses } from "@swivl-mono/helpers";
import { IoClose } from "react-icons/io5";

interface SelectChipProps {
  className?: string;
  handleRemoveOption: (option: string) => void;
  option: { label: string; value: string };
}

const SelectChip = ({ className, handleRemoveOption, option }: SelectChipProps) => {
  return (
    <button
      className={filterClasses(
        "group/chip relative flex h-full w-fit cursor-pointer items-center justify-center rounded-[1px] border border-grey-400 bg-white px-2 py-1 text-sm font-medium whitespace-nowrap text-black group-data-[disabled=true]:cursor-not-allowed group-data-[disabled=true]:bg-grey-100",
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        handleRemoveOption(option.value);
      }}
    >
      {option.label}
      <div
        className={filterClasses(
          "absolute top-1/2 right-1 flex size-4 -translate-y-1/2 cursor-pointer items-center justify-center rounded-xs text-white opacity-0 transition-all duration-200 ease-in-out",
          "group-data-[disabled=true]:hover:opacity-0",
          "group-hover/chip:bg-orange-500 group-hover/chip:opacity-100"
        )}
      >
        <IoClose />
      </div>
    </button>
  );
};

export { SelectChip };
